<template>
    <FloatingPanel>

        <div class="canvas-blocks-sky-code-BlockPanel">

            <accordion-input :open="true">
                <template #label>

                    <div class="font-medium text-gray-600">Code / Widget</div>

                </template>
                <template #content>

                    <small class="block mb-3 text-gray-500 text-muted">
                        Plaats hier de code (vanaf je widget)
                    </small>

                    <textarea
                        class="w-full px-3 py-2 mt-1 transition ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm min-h-32"
                        v-model="options.code"
                    />

                </template>
            </accordion-input>

            <CommonInputs :options="options" :open="false" />
            
        </div>

    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs';
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";

export default {
    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        AccordionInput,
    },
};
</script>
